import React, { Suspense } from 'react';

import { UhOhProps } from './types';

const Loading = React.lazy(() => import('$/components/Loading'));

export const UhOhPage: React.FC<UhOhProps> = ({ children, className, renderServerSide }) => {
  const [isClient, setClient] = React.useState(false);

  React.useEffect(() => {
    setClient(true);
  }, []);

  if (!isClient && !renderServerSide) {
    return (
      <Suspense>
        <Loading />
      </Suspense>
    );
  }

  return <div className={className ?? `h-100vh py-3`}>{children}</div>;
};
